import React from "react";
import Tooltip from "react-tooltip";
import { MdInfo } from "react-icons/md";
import PropTypes from "prop-types";

const divStyle = {
  display: "inline",
  marginLeft: "8px"
};

export const InfoIcon = ({ id, info }) => {
  return (
    <div style={divStyle} data-tip={info} data-for={id}>
      <MdInfo />
      <Tooltip id={id} className="tooltip-default-style"/>
    </div>
  );
};

InfoIcon.propTypes = {
  id: PropTypes.string,
  info: PropTypes.string.isRequired,
};
